'use strict';

exports = module.exports = require('./lib/memoizer')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ./~/react-intl/~/intl-format-cache/index.js
// module id = 35
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15